import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import haende1 from '../../assets/haende1.png';
import './navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className="protactics__navbar">
      <div className="protactics__navbar-links">
        <div className="protactics__navbar-links_logo img">
        <img src={haende1} />
        </div>
        <div className="protactics__navbar-links_container">
          <p><a href="#home">PROTACTICS Bodensee</a></p>
        </div>
      </div>
      <div className="protactics__navbar-sign">
      <p><a href="#home">Home</a></p>
          <p><a href="#blog">Standort</a></p>
          <p><a href="#blog">Mein Angebot</a></p>
          <p><a href="#possibility">Über mich</a></p>
          <p><a href="#footer">Kontakt</a></p>
      </div>
      <div className="protactics__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
        <div className="protactics__navbar-menu_container scale-up-center">
          <div className="protactics__navbar-menu_container-links">
            <p><a href="#home">Home</a></p>
            <p><a href="#blog">Standort</a></p>
            <p><a href="#blog">Mein Angebot</a></p>
            <p><a href="#possibility">Über mich</a></p>
            <p><a href="#footer">Kontakt</a></p>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
